import type React from 'react';
import { theme } from '@shared/styles/theme';

export const getStyles = (): Record<string, React.CSSProperties> => ({
  container: {
    width: '100%',
  },
  languageSection: {
    marginBottom: theme.spacing.xl,
    textAlign: 'center' as const,
  },
  languageLabel: {
    display: 'block',
    fontSize: theme.fontSize.sm,
    color: theme.colors.text.secondary,
    marginBottom: theme.spacing.md,
  },
  languageButtons: {
    display: 'flex',
    gap: theme.spacing.md,
    justifyContent: 'center',
  },
  languageButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    padding: `${theme.spacing.md} ${theme.spacing.xl}`,
    minHeight: '44px',
    backgroundColor: theme.colors.background.secondary,
    border: `2px solid ${theme.colors.border.light}`,
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: theme.fontSize.md,
    fontWeight: '600',
    color: theme.colors.text.primary,
    fontFamily: 'inherit',
    transition: 'all 0.2s',
  },
  languageButtonActive: {
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.background.green,
  },
  languageFlag: {
    fontSize: '20px',
  },
  title: {
    fontSize: theme.fontSize.xl,
    fontWeight: 'bold',
    color: theme.colors.text.primary,
    marginBottom: theme.spacing.xl,
    textAlign: 'center' as const,
  },
  errorMessage: {
    backgroundColor: theme.colors.error,
    color: theme.colors.text.white,
    padding: theme.spacing.md,
    borderRadius: '4px',
    marginBottom: theme.spacing.lg,
    fontSize: theme.fontSize.sm,
  },
  formGroup: {
    marginBottom: theme.spacing.lg,
  },
  label: {
    display: 'block',
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.sm,
    fontWeight: '600',
    marginBottom: theme.spacing.sm,
  },
  input: {
    width: '100%',
    padding: theme.spacing.md,
    minHeight: '44px',
    border: `2px solid ${theme.colors.border.light}`,
    borderRadius: '6px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.md,
    boxSizing: 'border-box' as const,
  },
  selectWrapper: {
    position: 'relative' as const,
  },
  select: {
    width: '100%',
    padding: theme.spacing.md,
    paddingRight: '40px',
    minHeight: '44px',
    border: `2px solid ${theme.colors.border.light}`,
    borderRadius: '6px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.md,
    boxSizing: 'border-box' as const,
    appearance: 'none' as const,
    cursor: 'pointer',
  },
  selectIcon: {
    position: 'absolute' as const,
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none' as const,
  },
  passwordWrapper: {
    position: 'relative' as const,
    display: 'flex',
    alignItems: 'center',
  },
  passwordInput: {
    width: '100%',
    padding: theme.spacing.md,
    paddingRight: '48px',
    minHeight: '44px',
    border: `2px solid ${theme.colors.border.light}`,
    borderRadius: '6px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.md,
    boxSizing: 'border-box' as const,
  },
  eyeButton: {
    position: 'absolute' as const,
    right: '4px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    minWidth: '44px',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  requirementsContainer: {
    marginTop: theme.spacing.sm,
    padding: theme.spacing.sm,
  },
  requirementRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.xs,
    marginBottom: '4px',
  },
  requirementText: {
    fontSize: theme.fontSize.xs,
  },
  errorText: {
    fontSize: theme.fontSize.xs,
    color: theme.colors.error,
    marginTop: theme.spacing.xs,
    margin: `${theme.spacing.xs} 0 0 0`,
  },
  primaryButton: {
    width: '100%',
    padding: theme.spacing.md,
    minHeight: '44px',
    backgroundColor: theme.colors.success,
    color: theme.colors.text.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: theme.fontSize.md,
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    marginTop: theme.spacing.lg,
    borderBottom: '4px solid rgba(0, 0, 0, 0.2)',
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
    margin: `${theme.spacing.xl} 0`,
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    backgroundColor: theme.colors.border.light,
  },
  dividerText: {
    color: theme.colors.text.secondary,
    fontSize: theme.fontSize.sm,
    whiteSpace: 'nowrap' as const,
  },
  secondaryButton: {
    width: '100%',
    padding: theme.spacing.md,
    minHeight: '44px',
    backgroundColor: theme.colors.accent.cyan,
    color: theme.colors.text.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: theme.fontSize.md,
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    borderBottom: '4px solid rgba(0, 0, 0, 0.2)',
  },
});

export const styles = getStyles();
